/**
 * 会员相关API接口
 * 实现会员注册、信息提交、查询等功能
 */

import { req } from '../utils/request'

export class Member {
  /**
   * 发送验证码
   * @param {String} mobile - 手机号
   * @returns {Promise}
   */
  sendVerificationCode(mobile) {
    return req.post('user.member/sendCode', { mobile })
  }
  
  /**
   * 创建会员（选择会员类型和等级）
   * @param {Object} data - { member_type, member_level, name, ... }
   * @returns {Promise}
   */
  createMember(data) {
    return req.post('user.member/create', data)
  }
  
  /**
   * 获取会员信息
   * @returns {Promise}
   */
  getMemberInfo() {
    return req.get('user.member/info')
  }
  
  /**
   * 提交注册会员信息（照片、职称、简介）
   * @param {Object} data - { photo, title, intro }
   * @returns {Promise}
   */
  submitRegisteredInfo(data) {
    return req.post('user.member/submitRegisteredInfo', data)
  }
  
  /**
   * 更新会员信息
   * @param {Object} data - 会员信息
   * @returns {Promise}
   */
  updateMemberInfo(data) {
    return req.post('user.member/update', data)
  }
  
  /**
   * 查询公开的注册会员列表
   * @param {Object} params - { address, page, limit }
   * @returns {Promise}
   */
  getPublicMembers(params) {
    return req.get('user.member/publicList', params)
  }
  
  /**
   * 获取会员详情
   * @param {Number} id - 会员ID
   * @returns {Promise}
   */
  getMemberDetail(id) {
    return req.get('user.member/detail', { id })
  }

  /**
   * 创建支付订单
   * @param {Object} params - { member_type, member_level, payment_type, payment_method, return_url }
   * @returns {Promise}
   */
  createPayment(params) {
    return req.post('user.member/createPayment', params)
  }
}

export default new Member()
